/* eslint-disable import/prefer-default-export */
export { default as Video } from './Video';
